var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tabs-select" },
    [
      _vm.tabs.length > 1
        ? _c("select-input", {
            attrs: { options: _vm.options, "disable-default": "" },
            model: {
              value: _vm.selected,
              callback: function($$v) {
                _vm.selected = $$v
              },
              expression: "selected"
            }
          })
        : _vm._e(),
      _c("div", { staticClass: "tabs__content" }, [_vm._t("default")], 2)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }